module.exports = __webpack_public_path__ + "static/media/section3.7a012633.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/quiz/image/section3.png
// module id = 299
// module chunks = 0